/**
 * User-visible Rack Power / PDU field labels (spreadsheet SoT for #995 multi-rack modal).
 */
export const RACK_POWER_FIELD_LABELS = {
  rackPduManufacturer: 'Manufacturer',
  rackPduModel: 'Model',
  rackPduMaxKwPerRack: 'Max KW per rack',
  rackPduPowerType: 'AC or DC power',
  rackPduInputPlugType: 'Input Plug Type',
  rackPduCountPerRack: 'How many rPDU per rack?',
  rackPduDcPowerShelves: 'How many DC Power Shelves',
  rackPduOutletSwitchingMonitored: 'Unit Monitored, Outlet Switching or Outlet Monitored?',
  rackPduCapacityAmps: 'Amp capacity',
  rackPduCapacityVolts: 'Voltage',
  rackPduCapacityKw: 'kW capacity',
  rackPduLoadReadingsKw: 'Load readings',
  rackPduMountingType: 'Mounting Type (Horizontal/Vertical)',
  rackPduOutletTypesQuantity: 'How many of each outlet type?',
  rackPduLocation: 'Location in Rack',
  rackAdditionalRackInformation: 'Additional Rack Configuration Information',
} as const;

export type RackPowerFieldLabelKey = keyof typeof RACK_POWER_FIELD_LABELS;
